"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _mui = require("tss-react/mui");
var _jsxRuntime = require("react/jsx-runtime");
const useStyles = (0, _mui.makeStyles)()(theme => ({
  buttonProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
}));
const LoadingButton = ({
  loading,
  children,
  ...buttonProps
}) => {
  const {
    classes
  } = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Button, {
    ...buttonProps,
    children: [children, ' ', loading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
      size: 24,
      className: classes.buttonProgress
    })]
  });
};
var _default = exports.default = LoadingButton;
//# sourceMappingURL=LoadingButton.js.map